import React from 'react';
import ReactDOM from 'react-dom';
import lax from 'lax.js';
import LocalizedStrings from 'react-localization';
import localeFile from '../../local/content';
import {connect} from 'react-redux';

const strings = new LocalizedStrings(localeFile);
class PlatinumSponsors extends React.Component {

    componentDidMount() {
        this.el = ReactDOM.findDOMNode(this)
        lax.addElement(this.el)
    }
    
    componentWillUnmount() {
        lax.removeElement(this.el)
    }

    render(){ strings.setLanguage(this.props.languageCode);
        return (
            <h3 className="lax" data-lax-preset="driftRight">{strings.Galerie_Des_Photos}</h3>
        );
    }
}
 
const mapStateToProps = state => {
    return {
      languageCode: state.languageCode
    }
  }

export default connect(mapStateToProps)(PlatinumSponsors);